module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section section-white"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-position": "left",
      "label-width": "120px"
    }
  }, [_c('div', {
    staticClass: "section-body"
  }, [
    [_c('el-form-item', {
      attrs: {
        "label": "订单自动取消:"
      }
    }, [_vm._v("\n            未付款订单，将在 "), _c('el-input', {
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "type": "number",
        "required": "",
        "min": "1",
        "placeholder": ""
      },
      model: {
        value: (_vm.form.order_cancel_time),
        callback: function($$v) {
          _vm.$set(_vm.form, "order_cancel_time", $$v)
        },
        expression: "form.order_cancel_time"
      }
    }), _vm._v("(分钟)之后取消\n        ")], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "订单自动确认:"
      }
    }, [_vm._v("\n            已发货订单，将在 "), _c('el-input', {
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "type": "number",
        "required": "",
        "min": "0",
        "placeholder": ""
      },
      model: {
        value: (_vm.form.order_finish_time),
        callback: function($$v) {
          _vm.$set(_vm.form, "order_finish_time", $$v)
        },
        expression: "form.order_finish_time"
      }
    }), _vm._v(" (天)后自动完成\n        ")], 1)]
  ], 2), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保 存")])], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-082bf805", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-082bf805"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/trade/ordersetting.vue
// module id = 2447
// module chunks = 0